class ProductTemplateCustom {
  constructor(container) {
    this.container = container;

    // Prevent double initialization
    if (this.container.dataset.initialized === "true") return;
    this.container.dataset.initialized = "true";

    this.variantData = JSON.parse(
      this.container.querySelector("[data-variants]").textContent
    );

    // Elements
    this.form = this.container.querySelector("form");
    this.variantSelect = this.form.querySelector('select[name="id"]');
    this.price = this.container.querySelector(".current-price");
    this.comparePrice = this.container.querySelector(".original-price");
    this.addToCartBtn = this.form.querySelector('[name="add"]');
    this.paymentBtn = this.container.querySelector(".shopify-payment-button");
    this.qtyVal = this.container.querySelector(".qty-val");
    this.qtyInput = this.container.querySelector(".qty-input");
    
    // Image Elements
    this.productImage = this.container.querySelector('.product-image');
    this.thumbnails = this.container.querySelectorAll('.thumbnail-item');

    this.initQty();
    this.initVariantSelection();
    this.initImageGallery(); 
    
    console.log("✅ Custom Product Page Initialized");
  }

  // --- NEW: Gallery Logic ---
  initImageGallery() {
    if (!this.thumbnails.length) return;

    this.thumbnails.forEach(thumb => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        
        // 1. Get the new image URL from data attribute
        const newSrc = thumb.getAttribute('data-target-src');
        
        // 2. Debugging check
        console.log("Thumbnail clicked, switching to:", newSrc);

        // 3. Update active class styling
        this.thumbnails.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');

        // 4. Update Main Image Source
        if (this.productImage && newSrc) {
          // Add a fade effect (optional)
          this.productImage.style.opacity = '0.5';
          
          setTimeout(() => {
            this.productImage.src = newSrc;
            // Also update srcset if it exists to prevent browser loading old image
            this.productImage.removeAttribute('srcset'); 
            this.productImage.style.opacity = '1';
          }, 150);
        }
      });
    });
  }

  initQty() {
    const minusBtn = this.container.querySelector(".qty-btn.minus");
    const plusBtn = this.container.querySelector(".qty-btn.plus");

    // Remove old listeners by cloning
    const newMinus = minusBtn.cloneNode(true);
    const newPlus = plusBtn.cloneNode(true);
    minusBtn.parentNode.replaceChild(newMinus, minusBtn);
    plusBtn.parentNode.replaceChild(newPlus, plusBtn);

    newMinus.addEventListener("click", () => {
      let qty = parseInt(this.qtyVal.textContent);
      if (qty > 1) qty--;
      this.qtyVal.textContent = qty;
      this.qtyInput.value = qty;
    });

    newPlus.addEventListener("click", () => {
      let qty = parseInt(this.qtyVal.textContent);
      qty++;
      this.qtyVal.textContent = qty;
      this.qtyInput.value = qty;
    });
  }

  initVariantSelection() {
    const buttons = this.container.querySelectorAll(".variant-button");
    if (buttons.length === 0) return;

    const findVariant = () => {
      const selectedOptions = [];
      const optionBlocks = this.container.querySelectorAll('.option-block');
      
      optionBlocks.forEach(block => {
        const activeButton = block.querySelector('.variant-button.active');
        if (activeButton) {
          selectedOptions.push(activeButton.dataset.value);
        }
      });
      
      if (selectedOptions.length !== optionBlocks.length) return null;

      return this.variantData.find(variant => {
        return selectedOptions.every((option, index) => option === variant.options[index]);
      });
    };

    buttons.forEach(btn => {
      btn.addEventListener("click", (event) => {
        event.preventDefault();

        const parentOptionBlock = btn.closest('.option-block');
        if (!parentOptionBlock) return;

        parentOptionBlock.querySelectorAll('.variant-button').forEach(sibling => {
          sibling.classList.remove('active');
        });

        btn.classList.add('active');

        const selectedVariant = findVariant();

        if (selectedVariant) {
          this.variantSelect.value = selectedVariant.id;
          this.updatePrices(selectedVariant);
          this.updateButtonState(selectedVariant);
          this.updateImageFromVariant(selectedVariant);
        } else {
          this.addToCartBtn.disabled = true;
          this.addToCartBtn.textContent = "Unavailable";
          if (this.paymentBtn) this.paymentBtn.style.display = "none";
        }
      });
    });
    
    // Set initial active state
    const initialVariantId = this.variantSelect.value;
    const initialVariant = this.variantData.find(v => v.id == initialVariantId);
    const optionBlocks = this.container.querySelectorAll('.option-block');
    
    if (initialVariant && optionBlocks.length > 0) {
      initialVariant.options.forEach((optionValue, optionIndex) => {
        const currentOptionBlock = optionBlocks[optionIndex];
        if (currentOptionBlock) {
          const escapedValue = CSS.escape(optionValue);
          const buttonToActivate = currentOptionBlock.querySelector(`.variant-button[data-value="${escapedValue}"]`);
          if (buttonToActivate) {
             currentOptionBlock.querySelectorAll('.variant-button').forEach(b => b.classList.remove('active'));
             buttonToActivate.classList.add('active');
          }
        }
      });
    }
  }

  updatePrices(variant) {
    // Basic formatting logic
    this.price.textContent = "$" + (variant.price / 100).toFixed(2);
    if (variant.compare_at_price > variant.price) {
      this.comparePrice.textContent = "$" + (variant.compare_at_price / 100).toFixed(2);
      this.comparePrice.style.display = "inline";
    } else {
      this.comparePrice.style.display = "none";
    }
  }
  
  // Update image when a variant option (like Color) is clicked
  updateImageFromVariant(variant) {
    if (!variant || !variant.featured_image) return;

    // 1. Update Main Image
    if (this.productImage) {
      this.productImage.src = variant.featured_image.src;
      this.productImage.alt = variant.featured_image.alt;
      this.productImage.removeAttribute('srcset'); 
    }

    // 2. Highlight matching thumbnail
    if(this.thumbnails.length > 0) {
        this.thumbnails.forEach(thumb => {
            thumb.classList.remove('active');
            // Compare filenames to handle URL differences
            const variantFile = variant.featured_image.src.split('?')[0].split('/').pop();
            const thumbFile = thumb.getAttribute('data-target-src').split('?')[0].split('/').pop();
            
            if(variantFile === thumbFile) {
                thumb.classList.add('active');
            }
        });
    }
  }

  updateButtonState(variant) {
    if (variant.available) {
      this.addToCartBtn.disabled = false;
      this.addToCartBtn.textContent = "Add to cart";
      if (this.paymentBtn) this.paymentBtn.style.display = "block";
    } else {
      this.addToCartBtn.disabled = true;
      this.addToCartBtn.textContent = "Sold Out";
      if (this.paymentBtn) this.paymentBtn.style.display = "none";
    }
  }
}

// Main initialization
function initProductTemplates() {
  document.querySelectorAll(".product-template-custom-section").forEach((container) => {
    new ProductTemplateCustom(container);
  });
}

document.addEventListener("DOMContentLoaded", initProductTemplates);

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener("shopify:section:load", (e) => {
    const container = e.target;
    if (container.classList.contains("product-template-custom-section")) {
      new ProductTemplateCustom(container);
    }
  });
}